<template>
  <div id="app" :class="['app ' + $route.name]">
    <transition name="fade">
      <div id="page" class="page" v-if="pageLoaded">
        <transition name="fade">
          <Menu v-if="menuVisible" @chooseCategoty="chooseCategoty" />
        </transition>
        <div
          class="mob menu-icon"
          @click="toggleMenu"
          :class="{ active: menuVisible }"
        >
          <span></span>
          <span></span>
          <span></span>
        </div>
        <Header
          @scrollToSection="scrollToSection"
          @chooseCategoty="chooseCategoty"
        />
        <router-view
          :faq="faq"
          :faq-loading="faqLoading"
          :order-history="orderHistory"
          :order-history-loading="orderHistoryLoading"
          :order-history-error="orderHistoryError"
          @load-order-history="getOrderHistory"
          @postNickname="postNickname"
          :currency="currency"
          :settings="settings"
          :server-ip="ip"
          :server-port="port"
          :isAuth="isAuth"
          :text-page-list="textPageList"
          :text-pages-loading="textPagesLoading"
          :text-pages-error="textPagesError"
          @login="login"
          @forgotPass="forgotPass"
          @registration="registration"
          @open-sign-up="openSignUp"
          @sendContactForm="sendContactForm"
          :addToCartChosenItem="addToCartChosenItem"
          @addToCart="addToCart"
          @chooseCategoty="chooseCategoty"
          :activeCategory="activeCategory"
          @orderSubmit="orderSubmit"
          :checkout-loading="checkoutLoading"
          @refresh-cart="getCartContents"
        />
        <Footer @chooseCategoty="chooseCategoty" :settings="settings" />
        <transition name="fade">
          <Login
            v-if="signInModalIsVisible"
            :login-loading="loginLoading"
            :forgot-pass-loading="forgotPassLoading"
            @login="login"
            @forgotPass="forgotPass"
          />
        </transition>
        <transition name="fade">
          <Registration
            v-if="signUpModalIsVisible"
            :loading="registerLoading"
            :text-page-list="textPageList"
            @registration="registration"
          />
        </transition>
        <transition name="fade">
          <ContactUs
            v-if="contactUsModalIsVisible"
            :text-page-list="textPageList"
            :success-message="successMessage"
            @sendContactForm="sendContactForm"
          />
        </transition>

        <transition name="fade">
          <PassModal v-if="passModalIsVisible" />
        </transition>
        <cookie-modal :textPageList="textPageList"></cookie-modal>
      </div>
    </transition>
  </div>
</template>

<script>
import { fetchCsrfToken } from '@/axios'
import { loadScriptsFromString } from '@/utils/load_scripts'
import slugify from '@/utils/slugify'
import { scroller } from 'vue-scrollto/src/scrollTo'
import { mapActions, mapState } from 'vuex'
import ContactUs from './components/ContactUs.vue'
import CookieModal from './components/CookieModal.vue'
import Footer from './components/Footer.vue'
import Header from './components/Header.vue'
import Login from './components/Login.vue'
import Menu from './components/Menu.vue'
import PassModal from './components/PassModal.vue'
import Registration from './components/Registration.vue'
import useCurrency from './utils/useCurrency'

export default {
  name: 'app',
  components: {
    Header,
    Footer,
    Menu,
    Login,
    Registration,
    CookieModal,
    ContactUs,
    PassModal,
  },
  data: function () {
    return {
      hostname: '',
      cookesModalIsVisible: false,
      settings: {},
      nav: [
        {
          title: 'Main',
          path: '/',
        },
        {
          title: 'Rules',
          path: '/rules',
        },
        {
          title: 'Faq',
          path: '/faq',
        },
        {
          title: 'How it works',
          scrollSection: '#howItWorks',
        },
        {
          title: 'Shop',
          path: '/categories',
        },
      ],
      pageLoaded: false,
      menuVisible: false,
      registerLoading: false,
      loginLoading: false,
      forgotPassLoading: false,
      isAuth: false,
      error: '',
      successMessage: '',
      textPageList: [],
      textPagesLoading: false,
      textPagesError: '',
      textPageTitle: '',
      textPageHeader: '',
      checkoutLoading: false,
      textPageContent: '',
      orderHistory: [],
      orderHistoryLoading: false,
      orderHistoryError: '',
      imgDomain: '',
      addToCartChosenItem: '',
      currency: '',
      cartContents: [],
      totalSum: '0.00',
      categories: [],
      activeCategory: '',
      socialLinks: [],
      faq: [],
      faqLoading: false,
      signInModalIsVisible: false,
      signUpModalIsVisible: false,
      contactUsModalIsVisible: false,
      passModalIsVisible: false,
      ip: '',
      port: '',
    }
  },
  watch: {
    $route(to) {
      window.scrollTo(0, 0)
      this.closeMenu()
      if (
        this.isAuth &&
        to.path === '/profile' &&
        to.query.section === 'orders'
      ) {
        this.getOrderHistory()
      }
      if (to.path === '/faq') {
        this.getFaq()
      }

      this.clearError()
    },
  },
  methods: {
    ...mapActions('app', ['fetchLanguages']),
    openPassModal() {
      this.passModalIsVisible = true
    },
    closePassModal() {
      this.passModalIsVisible = false
    },
    back() {
      this.$router.go(-1)
    },
    openContactModal() {
      this.contactModalIsVisible = true
    },
    closeContactModal() {
      this.contactModalIsVisible = false
    },
    async getFaq() {
      if (this.faqLoading) {
        return
      }

      this.faqLoading = true

      try {
        const res = await this.$http.get('faq')

        this.faq = Array.isArray(res.data.payload) ? res.data.payload : []
      } finally {
        this.faqLoading = false
      }
    },
    goToPage(item) {
      let newItem
      if (item == 'privacy') {
        for (let i = 0; i < this.textPageList.length; i++) {
          if (this.textPageList[i].title.toLowerCase().includes('privacy')) {
            newItem = this.textPageList[i]
          }
        }
      } else if (item == 'terms') {
        for (let i = 0; i < this.textPageList.length; i++) {
          if (this.textPageList[i].title.toLowerCase().includes('terms')) {
            newItem = this.textPageList[i]
          }
        }
      } else if (item == 'cookie') {
        for (let i = 0; i < this.textPageList.length; i++) {
          if (this.textPageList[i].title.toLowerCase().includes('cookie')) {
            newItem = this.textPageList[i]
          }
        }
      } else {
        newItem = item
      }
      this.$router.push({
        path: '/pages/' + slugify(newItem.title),
        params: {
          data: newItem.title.replace(/\//g, '').replace(/ /g, '-'),
        },
      })

      this.getTextPageContent(newItem.id)
      this.closeSignUp()
    },
    async getTextPageContent(idOrSlug) {
      this.textPageTitle = ''
      this.textPageHeader = ''
      this.textPageContent = ''

      try {
        let pageId = idOrSlug

        // Anything non-numeric is a URL slug.
        if (!/^\d+$/.test(String(idOrSlug))) {
          const response = await this.$http.get('static-pages')
          const pages = Array.isArray(response.data?.payload)
            ? response.data.payload
            : []

          const requestedSlug = String(idOrSlug)
            .replace(/\//g, '')
            .trim()
            .toLowerCase()

          const page = pages.find((item) => {
            const itemSlug = slugify(item.title).toLowerCase()
            return itemSlug === requestedSlug
          })

          if (!page) {
            console.error('Static page not found:', requestedSlug)
            return
          }

          pageId = page.id
        }

        const response = await this.$http.get(`static-pages/${pageId}`)
        const page = response.data?.payload

        this.textPageTitle = page?.title || ''
        this.textPageContent = page?.content || ''
        this.textPageHeader = page?.header || ''
      } catch (error) {
        console.error('Failed to load static page:', error)

        if (error.response?.status === 401) {
          this.openSignIn()
        }
      }
    },
    async getTextPages() {
      if (this.textPagesLoading) {
        return
      }

      this.textPagesLoading = true
      this.textPagesError = ''

      try {
        const response = await this.$http.get('static-pages')

        const payload = response.data?.payload

        this.textPageList = Array.isArray(payload) ? payload : []

        if (!this.textPageList.length) {
          this.textPagesError = this.$t(
            'Юридические документы пока не добавлены',
          )
        }
      } catch (error) {
        this.textPageList = []

        if (error.response?.status === 401) {
          this.openSignIn()
          return
        }

        this.textPagesError =
          error.response?.data?.message ||
          this.$t('Не удалось загрузить документы')
      } finally {
        this.textPagesLoading = false
      }
    },
    cookiesModal() {
      const cookiesAccepted = localStorage.getItem('cookiesAccepted')

      if (!cookiesAccepted) {
        this.cookesModalIsVisible = true
      }
    },
    declineCookies() {
      this.cookesModalIsVisible = false
    },
    acceptCookies() {
      localStorage.setItem('cookiesAccepted', 'true')
      this.cookesModalIsVisible = false
    },
    postNickname(nickname) {
      let data = {
        nickname: nickname,
      }
      this.$http
        .post('set-nickname', data)
        .then((res) => {
          console.log(res)
          if (res.status == '200') {
            this.$router.push({ path: '/categories' })
          }
        })
        .catch((res) => {
          console.log(res)
          this.error = res.response.data.message
        })
    },
    getSettings() {
      let self = this
      this.$http
        .get('settings')
        .then((res) => {
          this.ip = res.data.payload?.game_server?.host
          this.port = res.data.payload?.game_server?.port
          const currentSettings = self.settings
          self.settings = res.data.payload

          if (!currentSettings || !Object.keys(currentSettings).length) {
            const snippet = res.data.payload.google_tag
            if (snippet) {
              loadScriptsFromString(snippet)
            }
          }
        })
        .catch(() => {})
    },
    clearError() {
      this.error = ''
    },
    async login(data) {
      if (this.loginLoading) {
        return
      }

      this.loginLoading = true
      this.clearError()

      try {
        const res = await this.$http.post('login', data)

        if (res.data.status === 'OK') {
          this.isAuth = true
          this.clearError()
          this.getOrderHistory()
          this.getCartContents()
          this.closeSignIn()
        } else {
          this.error = res.data.message
        }
      } catch (err) {
        this.error =
          this.translateApiError(err.response?.data) || this.$t('Login failed')
      } finally {
        this.loginLoading = false
      }
    },
    async forgotPass(data) {
      if (this.forgotPassLoading) {
        return
      }

      this.forgotPassLoading = true
      this.clearError()
      this.successMessage = ''

      try {
        const res = await this.$http.post('user/reset-password', data)

        if (res.data.status === 'OK') {
          this.successMessage = res.data.message || 'Success'

          this.error = ''

          setTimeout(() => {
            this.successMessage = ''
          }, 2000)
        } else {
          this.error =
            this.translateApiError(res.data) || this.$t('Password reset failed')
        }
      } catch (err) {
        this.error =
          this.translateApiError(err.response?.data) ||
          this.$t('Password reset failed')
      } finally {
        this.forgotPassLoading = false
      }
    },
    async registration(data) {
      if (this.registerLoading) {
        return
      }

      if (data.password !== data.passConfirm) {
        this.error = this.$t('Password confirmation failed!')
        return
      }

      this.registerLoading = true

      try {
        const res = await this.$http.post('register', data)

        if (res.data.status === 'OK') {
          this.clearError()
          this.isAuth = true
          this.getCartContents()
          this.closeSignUp()
        } else {
          this.error = res.data.message
        }
      } catch (err) {
        this.error =
          this.translateApiError(err.response?.data) ||
          this.$t('Registration failed')
      } finally {
        this.registerLoading = false
      }
    },
    logout() {
      this.$http
        .post('logout')
        .then(() => {
          if (this.$route.name != 'Home') {
            this.$router.push({ path: '/' })
          }
          this.isAuth = false
          this.$router.push({ path: '/' })
        })
        .catch((res) => {
          if (res.response.status === 401) {
            console.log(res)
          }
        })
    },
    async getOrderHistory() {
      if (this.orderHistoryLoading) {
        return
      }

      this.orderHistoryLoading = true
      this.orderHistoryError = ''

      try {
        const res = await this.$http.get('purchase/history')

        this.orderHistory = Array.isArray(res.data.payload)
          ? res.data.payload
          : []
      } catch (error) {
        this.orderHistory = []

        if (error.response?.status === 401) {
          this.openSignIn()
          return
        }

        this.orderHistoryError =
          this.translateApiError(error.response?.data) ||
          this.$t('Не удалось загрузить историю покупок')
      } finally {
        this.orderHistoryLoading = false
      }
    },
    // Бэк отдаёт transkey — ключ перевода для сообщения об ошибке
    // (+ amount/currency для сообщений с суммой). Если его нет — берём message как есть.
    translateApiError(responseData) {
      if (!responseData) {
        return ''
      }

      if (responseData.transkey) {
        return this.$t(responseData.transkey, {
          amount: responseData.amount,
          currency: responseData.currency,
        })
      }

      return responseData.message || responseData.error || ''
    },
    formatDate(num) {
      let objectDate = new Date(num * 1000)
      let day = objectDate.getDate()
      if (day < 10) {
        day = '0' + day
      }
      let month = objectDate.getMonth() + 1
      if (month < 10) {
        month = `0${month}`
      }
      let year = objectDate.getFullYear()

      function padTo2Digits(x) {
        return String(x).padStart(2, '0')
      }
      let hoursAndMinutes =
        padTo2Digits(objectDate.getHours()) +
        ':' +
        padTo2Digits(objectDate.getMinutes())
      let format = day + '.' + month + '.' + year + ' ' + hoursAndMinutes

      return format
    },

    getSocialLinks() {
      return this.$http
        .get('social-links')
        .then((res) => {
          this.socialLinks = res.data.payload
        })
        .catch(() => {})
    },
    closeSignIn() {
      this.error = ''
      this.signInModalIsVisible = false
      document.body.style.overflow = 'auto'
    },
    closeSignUp() {
      this.signUpModalIsVisible = false
      document.body.style.overflow = 'auto'
    },
    openSignIn() {
      this.error = ''
      document.body.style.overflow = 'hidden'
      this.signUpModalIsVisible = false
      this.signInModalIsVisible = true
    },
    closeContactUs() {
      this.contactUsModalIsVisible = false
      document.body.style.overflow = 'auto'
    },
    openContactUs() {
      this.error = ''
      document.body.style.overflow = 'hidden'
      this.contactUsModalIsVisible = true
    },
    openSignUp() {
      this.error = ''
      document.body.style.overflow = 'hidden'
      this.signInModalIsVisible = false
      this.signUpModalIsVisible = true
    },
    sendContactForm(data) {
      this.$http
        .post('contact-us', data)
        .then((res) => {
          if (res.data.status == 'OK') {
            let self = this
            this.successMessage = this.$t(
              'Thank you your message has been sent',
            )
            this.error = ''
            setTimeout(() => {
              self.successMessage = ''
            }, 2000)
          } else {
            this.error = res.data.message
          }
        })
        .catch((res) => {
          this.error = res.response.data.message
        })
    },
    removeOneFromCart(item, id) {
      let self = this

      const type = item.type || 'product'

      let cartItem = {
        id: id,
        count: 1,
        type: type,
      }

      if (item.count > 1) {
        cartItem = {
          id: id,
          count: item.count - 1,
          type: type,
        }
      }

      this.$http
        .post('cart/add', cartItem)
        .then((res) => {
          self.cartContents = res.data.cart
          this.getCartContents()
        })
        .catch((error) => {
          console.error('Error updating cart:', error)
        })
    },
    removeFromCart(item, id) {
      let self = this

      let cartItem = {
        id: id,
        type: item.type || 'product',
      }

      console.log('Removing item:', cartItem)

      this.$http
        .post('cart/remove', cartItem)
        .then((res) => {
          self.cartContents = res.data.cart
          this.getCartContents()
        })
        .catch((error) => {
          console.error('Error removing item from cart:', error)
        })
    },
    addToCart(item, id, type = 'product') {
      if (!this.isAuth) {
        this.openSignIn()
        return
      }

      let self = this

      let cartItem = {
        id: id,
        count: 1,
        type: type,
      }

      for (let i = 0; i < this.cartContents.length; i++) {
        const cartItemType = this.cartContents[i].type || 'product'

        if (this.cartContents[i].item_id == id && cartItemType === type) {
          cartItem = {
            id: id,
            count: this.cartContents[i].count + 1,
            type: type,
          }

          break
        }
      }

      this.$http
        .post('cart/add', cartItem)
        .then((res) => {
          this.getCartContents()

          self.addToCartChosenItem = cartItem.id
          self.cartContents = res.data.cart

          setTimeout(() => {
            self.addToCartChosenItem = ''
          }, 2000)
        })
        .catch((error) => {
          console.error('Error adding to cart:', error)

          if (error.response?.status === 401) {
            this.openSignIn()
          }
        })
    },
    emptyCart() {
      this.$http
        .post('cart/clear')
        .then((res) => {
          if (res.data.status == 'OK') {
            this.getCartContents()
          }
        })
        .catch(() => {})
    },
    getCartContents() {
      this.$http
        .get('cart/contents')
        .then((res) => {
          console.log(res.data.cart)
          this.cartContents = res.data.cart

          let total = 0
          for (let i in this.cartContents) {
            let newPrice
            if (this.cartContents[i].count > 1) {
              newPrice =
                this.cartContents[i].count *
                parseFloat(this.cartContents[i].item.price)
            } else {
              newPrice = parseFloat(this.cartContents[i].item.price)
            }
            total += newPrice
          }
          this.totalSum = total.toFixed(2)
        })
        .catch(() => {})
    },
    scrollToSection(path) {
      if (this.$route.name != 'Home') {
        this.$router.push({ path: '/' })
      }
      setTimeout(() => {
        const firstScrollTo = scroller()
        firstScrollTo(path)
      }, 200)
    },
    closeMenu() {
      this.menuVisible = false
      document.body.style.overflow = 'auto'
    },
    toggleMenu() {
      this.menuVisible = !this.menuVisible
      window.scrollTo(0, 0)
      if (this.menuVisible) {
        document.body.style.overflow = 'hidden'
      } else {
        document.body.style.overflow = 'auto'
      }
    },
    menuHeight() {
      const doc = document.documentElement
      doc.style.setProperty('--vh', `${window.innerHeight * 0.01}px`)
    },
    chooseCategoty(item) {
      this.activeCategory = item
      if (this.$route.path != '/products' + item.url) {
        this.$router.push({ path: '/products' + item.url })
      }
    },
    getCategories() {
      this.$http
        .get('categories')
        .then((res) => {
          this.categories = res.data.payload
          for (const obj of this.categories) {
            if (obj.url.replace(/\//g, '') == this.$route.params.url) {
              this.activeCategory = obj
              break
            }
          }
        })
        .catch(() => {})
    },
    async orderSubmit(data) {
      if (this.checkoutLoading) {
        return
      }

      this.checkoutLoading = true
      this.clearError()

      try {
        const response = await this.$http.post('orders/checkout', data, {
          timeout: 30000,
        })

        const responseData = response?.data || {}

        if (responseData.status !== 'OK') {
          this.error =
            this.translateApiError(responseData) ||
            this.$t('Не удалось создать платёж')

          return
        }

        if (!responseData.redirect_url) {
          this.error = this.$t('Платёжная система не вернула ссылку для оплаты')

          return
        }

        window.location.assign(responseData.redirect_url)
      } catch (error) {
        this.error =
          this.translateApiError(error.response?.data) ||
          error.message ||
          this.$t('Не удалось открыть платёжную систему')
      } finally {
        this.checkoutLoading = false
      }
    },
    getDomainName(hostName) {
      return hostName.substring(
        hostName.lastIndexOf('.', hostName.lastIndexOf('.') - 1) + 1,
      )
    },
  },
  mounted: async function () {
    await fetchCsrfToken()
    await this.fetchLanguages()
    this.hostname = this.getDomainName(window.location.hostname)
    this.getTextPages()
    this.getSettings()
    this.getCategories()
    this.getSocialLinks()
    this.cookiesModal()
    this.currency = process.env.VUE_APP_CURRENCY
    this.imgDomain = process.env.VUE_APP_STATIC_DOMAIN
    this.pageLoaded = true
    let self = this

    if (this.$route.path === '/faq') {
      this.getFaq()
    }

    self.$http
      .get('is-auth')
      .then((res) => {
        console.log('auth: ' + res.data.authenticated)
        self.isAuth = res.data.authenticated

        if (res.data.authenticated) {
          self.getOrderHistory()
          self.getCartContents()
        }
      })
      .catch(() => {})

    // Sync currency from composable
    const currencyComposable = useCurrency(this.$http)
    currencyComposable.fetchCurrencies().then(() => {
      this.currency = currencyComposable.getCurrencyCode()
    })
    currencyComposable.onCurrencyChange(() => {
      this.currency = currencyComposable.getCurrencyCode()
    })
  },
  computed: {
    ...mapState({
      currentLanguage: (state) => state.app.currentLanguage,
    }),
  },
}
</script>
